export default __webpack_public_path__ + "static/media/16.face2d7d.jpeg";